import { createStore } from 'vuex'

export default createStore({
    state: {
        topBarClicked: 0,
        deteil: ['hahah'] as any,
        topBannerSource: '',
        BannerSourceBackUp: ''
    },
    getters: {
    },
    mutations: {
        setTopbarClickedIndex(state, index: any) {
            state.topBarClicked = index
        },
        setDetail(state, detail: any) {
            state.deteil = detail
        },
        setTopBannerSource(state, img: any) {
            state.topBannerSource = img
        },
        setBannerSourceBackUp(state, img: any) {
            state.BannerSourceBackUp = img
        }
    },
    actions: {

    },
    modules: {
    }
})
